<template>
  <b-row v-if="user&&user.user_type!=='customer'">
    <b-col v-for="a in topCardList" :key="a.name" xxl="3" sm="6">
      <b-card no-body class="card-animate">
        <b-card-body>
          <div class="d-flex justify-content-between">
            <div>
              <p class="fw-medium text-muted mb-0">{{ a.name }}</p>
              <h2 class="mt-2 ff-secondary fw-semibold">
                <count-to
                  :startVal="0"
                  :endVal="a.value"
                  :duration="5000"
                ></count-to>
              </h2>
              <p class="mb-0 text-muted">
                <b-badge class="bg-light mt-2 text-success mb-0 me-2">
                  {{ a.value1 }} </b-badge
                >{{ a.name1 }}
              </p>
            </div>
            <div>
              <div class="avatar-sm flex-shrink-0">
                <span
                  class="avatar-title bg-soft-info text-info rounded-circle fs-4"
                >
                  <i :class="a.icon"></i>
                </span>
              </div>
            </div>
          </div>
        </b-card-body>
      </b-card>
    </b-col>
  </b-row>
  <b-card no-body id="tasksList">
    <b-card-header class="border-0">
      <div class="d-flex align-items-center">
        <h5 class="card-title mb-0 flex-grow-1">
          {{ this.$t("menu.after-sales_service.service_request") }}
        </h5>
        <div class="flex-shrink-0">
          <div class="d-flex flex-wrap gap-2">
            <b-button
              variant="primary"
              class="add-btn"
              v-perm="'service.post'"
              @click="handlerJump('add')"
            >
              <i class="ri-add-line align-bottom me-1"></i>
              {{ this.$t("base.add") }}
            </b-button>
          </div>
        </div>
      </div>
    </b-card-header>
    <!-- 搜索栏 -->
    <b-card-body
      class="searchBox border border-dashed border-end-0 border-start-0"
    >
      <b-form>
        <!-- overflow-auto -->
        <b-row class="g-3">
          <b-col xxl="3" >
            <div class="search-box">
              <input
                type="text"
                class="form-control search"
                :placeholder="`${$t('page.device_name')}${(user&&user.user_type==='customer'?'':('/'+$t(
                  'page.customer_name'
                )))} / ${$t('page.contact')} / ${$t('page.contact_phone')}`"
                v-model="searchQuery"
              />
              <i class="ri-search-line search-icon"></i>
            </div>
          </b-col>
          <b-col xxl="3" >
            <flat-pickr
              v-model="filterdate"
              :placeholder="$t('page.selectCreationTime')"
              :config="dateconfig"
              class="form-control"
            ></flat-pickr>
          </b-col>
          <!-- 紧急程度 -->
          <b-col xxl="2" >
            <div class="input-light">
              <Multiselect
                :placeholder="$t('page.work-order.priority.text')"
                v-model="filtervalue1"
                :close-on-select="true"
                :searchable="true"
                :create-option="true"
                :options="priorityOptions"
                :can-clear="false"
                :can-deselect="false"
              />
            </div>
          </b-col>
          <!-- 类型 -->
          <b-col xxl="2" >
            <div class="input-light">
              <Multiselect
                :placeholder="this.$t('page.repair-request.SelectRequestType')"
                v-model="typeFilter"
                :close-on-select="true"
                :searchable="true"
                :create-option="true"
                :options="typeOptions"
                :can-clear="false"
                :can-deselect="false"
              />
            </div>
          </b-col>
          <b-col  xxl="2"  class="d-flex justify-content-end align-items-end">
            <b-button
              type="button"
              variant="primary"
              @click="searchData"
              class="me-2"
            >
              <i class="ri-search-line me-1 align-bottom"></i>
              {{ this.$t("search") }}
            </b-button>
            <b-button
                type="button"
                variant="info"
                @click="resetSearch"
            >
              <i class="ri-restart-line me-1 align-bottom"></i>
              {{ this.$t("base.reset") }}
            </b-button>
          </b-col>

        </b-row>
      </b-form>
    </b-card-body>
    <!-- 表单区域 -->
    <b-card-body class="overflow-auto">
      <ul class="nav nav-tabs nav-tabs-custom nav-success mb-3" role="tablist">
        <li
          class="nav-item"
          v-for="(tabItem, index) in tabOptions"
          :key="index"
        >
          <b-link
            class="nav-link py-3"
            :class="tabItem.value == filtervalue2 ? 'active' : ''"
            data-bs-toggle="tab"
            role="tab"
            @click.prevent="checkTab(tabItem.value)"
            aria-selected="true"
          >
            <i :class="tabItem.icon" class="me-1 align-bottom"></i>
            {{ tabItem.text }}
            <b-badge
              v-if="tabItem.tipNum > 0"
              variant="danger"
              class="align-middle ms-1"
              >{{ tabItem.tipNum }}</b-badge
            >
          </b-link>
        </li>
      </ul>
      <div class="table-responsive table-card">
        <table class="table align-middle table-nowrap mb-0" id="tasksTable">
          <thead class="table-light text-muted">
            <tr>
              <th
                class="sort"
                :data-sort="head"
                v-for="(head, h_index) in tableHead"
                :key="h_index"
                v-show="user&&user.user_type!=='customer'||(user&&user.user_type=='customer'&&(head!==$t('page.work-order.customer-name')||head===$t('page.user.department')))"
              >
                {{ head }}
              </th>
            </tr>
          </thead>
          <tbody class="list form-check-all">
            <tr v-for="(body, index) in tableBody" :key="index">
              <td>
                {{ body.number }}
              </td>
              <td class="cursor-pointer">
                <a href="javascript:" @click="handlerJump('detail', body.id)">
                  {{ body.device_root_sn }}
                </a>
              </td>
              <td>{{ body.custom_device_name }}</td>
              <td>{{ body.customer_contact_name }}</td>
              <td v-if="user.user_type==='customer'">{{body.customer_contact_department||'-'}}</td>
              <td>{{ body.customer_contact_number }}</td>
              <td v-if="user.user_type!=='customer'">{{ body.customer_txt }}</td>
              <td>{{ body.expectation_at }}</td>
              <td>
                {{
                 body.type_txt 
                }}
              </td>
              <td>
                <span :class="['badge', priorityColor[body.priority]]">{{
                  filterPriority(body.priority)
                }}</span>
              </td>
              <td>
                <span :class="['badge', statusColor[body.status]]">{{
                  getStatusTxt(SERVICE_STATUS_TXT, body.status)
                }}</span>
              </td>
              <td>
                {{ formatDatetime(body.created_at) }}
              </td>
              <td>
                <div class="d-flex action-style">
                  <div
                    class="me-1 cursor-pointer"
                    @click="handlerJump('detail', body.id)"
                  >
                    <i class="ri-eye-fill"></i>
                  </div>
                  <div
                    v-if="
                      ![
                        SERVICE_STATUS_CLOSED,
                        SERVICE_STATUS_PROCESSED,
                      ].includes(parseInt(body.status))&&body.type!=5
                    "
                    class="me-1 cursor-pointer"
                    @click="handlerAction('add', body)"
                    v-perm="'order.post'"
                  >
                    <i class="ri-shield-flash-fill"></i>
                  </div>
                  <div
                    v-if="
                      ![
                        SERVICE_STATUS_CLOSED,
                        SERVICE_STATUS_PROCESSED,
                      ].includes(parseInt(body.status))
                    "
                    class="cursor-pointer"
                    v-perm="'service.patch'"
                    @click="handlerAction('delete', body)"
                  >
                    <i class="ri-close-circle-fill"></i>
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
        <table-loading
          :count="tab_info_length"
          :table-loaded="tableLoaded"
          :table-loading="tableLoading"
        ></table-loading>
      </div>
    </b-card-body>
  </b-card>
  <Pagination
    v-if="tab_info_length"
    v-model:page="page"
    v-model:perPage="perPage"
    :pages="pages"
    :prePageOption="prePageOption"
    :tab_info_length="tab_info_length"
    @update:page="pageChange"
    @update:perPage="pageSizeChange"
    class="me-5 my-3"
  ></Pagination>
</template>

<script>
import {
  getRepairList,
  deleteRepairService,
  patchRepairService,
  statisticsServiceRequest,
} from "@/service/index";
import Swal from "sweetalert2";
import TableLoading from "@/views/widgets/table-loading";
import {
  SERVICE_STATUS_CLOSED,
  SERVICE_STATUS_TO_BE_CLASSIFIED,
  SERVICE_STATUS_PROCESSED,
  SERVICE_STATUS_PENDING,
  SERVICE_STATUS_TXT,
  WO_TYPE,
} from "@/config/common";
import { getStatusTxt, formatDatetime } from "@/helpers/common";
import {
  alertComfirmWithTextarea,
  successMsg,
  alertError,
} from "@/helpers/swal";
import { CountTo } from "vue3-count-to";
import {
  // tableHead,
  // tableBody,
  priorityOptions,
  statusOptions,
  priorityColor,
  statusColor,
  filterStatus,
  filterPriority,
} from "./data.js";
import i18n from "@/i18n";

const typeOptions = [
  { label: i18n.global.t("page.all"), value: "" },
  ...WO_TYPE,
  { label: i18n.global.t("page.repair-request.NotClassified"), value: "0" },
];
let routeFrom = null;
export default {
  name: "repair-request",
  data() {
    return {
      tableHead:localStorage.getItem("user")&&JSON.parse(localStorage.getItem("user")).user_type==="customer"?[
        i18n.global.t('page.repair-request.service_request_no'),
        i18n.global.t('page.work-order.device-root-sn'),
        i18n.global.t('page.work-order.device-name'),
        i18n.global.t('page.work-order.contact'),
        i18n.global.t('page.user.department'),
        i18n.global.t('page.work-order.contact-phone'),
        i18n.global.t('also.ExpectedDate'),
        i18n.global.t('page.repair-request.RequestType'),
        i18n.global.t('page.work-order.priority.text'),
        i18n.global.t('page.status'),
        i18n.global.t('page.create-time'),
        i18n.global.t('page.operation')]:[
          i18n.global.t('page.repair-request.service_request_no'),
          i18n.global.t('page.work-order.device-root-sn'),
          i18n.global.t('page.work-order.device-name'),
          i18n.global.t('page.work-order.contact'),
          i18n.global.t('page.work-order.contact-phone'),
          i18n.global.t('page.work-order.customer-name'),
          i18n.global.t('also.ExpectedDate'),
          i18n.global.t('page.repair-request.RequestType'),
          i18n.global.t('page.work-order.priority.text'),
          i18n.global.t('page.status'),
          i18n.global.t('page.create-time'),
        i18n.global.t('page.operation')],
      // tableBody,
      priorityOptions,
      statusOptions,
      priorityColor,
      statusColor,
      typeOptions,
      tableBody: [],
      /* 分页start */
      tab_info_length: 0,
      page: 1,
      perPage: 10,
      prePageOption: [10, 20, 30, 40, 50],
      pages: [],
      /* 分页end */
      dateconfig: {
        wrap: true,
        altFormat: "Y-m-d",
        altInput: true,
        dateFormat: "Y-m-d",
      },
      searchQuery: null,
      filterdate: null,
      filtervalue1: null,
      filtervalue2: "",
      typeFilter: null,
      tableLoading: false,
      tableLoaded: false,
      SERVICE_STATUS_TXT,
      SERVICE_STATUS_PROCESSED,
      SERVICE_STATUS_TO_BE_CLASSIFIED,
      SERVICE_STATUS_CLOSED,
      checkTabVal: "",
      tabOptions: [
        {
          value: "",
          text: this.$t("page.repair-request.TotalRequest"),
          icon: "ri-layout-grid-fill",
          tipNum: 0,
        },
        {
          value: SERVICE_STATUS_PENDING,
          text: this.$t("page.service-request.status.pending"),
          icon: "ri-creative-commons-by-fill",
          tipNum: 0,
        },
        {
          value: SERVICE_STATUS_PROCESSED,
          text: this.$t("page.service-request.status.processed"),
          icon: "ri-checkbox-circle-fill",
          tipNum: 0,
        },
        {
          value: SERVICE_STATUS_CLOSED,
          text: this.$t("page.service-request.status.canceled"),
          icon: "ri-close-circle-fill",
          tipNum: 0,
        },
      ],
      topCardList: [
        {
          name: this.$t("page.repair-request.RequestsThisMonth"),
          name1: this.$t("page.repair-request.TotalRequest"),
          value: 0,
          value1: 0,
          icon:'ri-git-pull-request-line'
        },
        {
          name: this.$t("page.repair-request.PendingRequestsThisMonth"),
          name1: this.$t("page.repair-request.TotalPendingRequests"),
          value: 0,
          value1: 0,
          icon:'ri-todo-line'

        },
        {
          name: this.$t("page.repair-request.ClosedRequestsThisMonth"),
          name1: this.$t("page.repair-request.TotalClosedRequests"),
          value: 0,
          value1: 0,
          icon:'ri-check-line'

        },
        {
          name: this.$t("page.repair-request.CanceledRequestsThisMonth"),
          name1: this.$t("page.repair-request.TotalCanceledRequests"),
          value: 0,
          value1: 0,
          icon:'ri-close-circle-line'

        },
      ],
    };
  },
  computed: {
    user() {
      return JSON.parse(localStorage.getItem("user"));
    },
  },
  watch: {
    tableBody: {
      handler() {
        this.setPages();
      },
      deep: true,
    },
    perPage() {
      this.setPages();
    },
  },
  mounted() {
    // this.page = 1;
    // this.initRepairRequest();
    this.getStatisticsServiceRequest();
  },
  beforeRouteEnter(to, from, next) {
    routeFrom = from.name;
    next();
  },
  activated() {
    this.refresh(
      ["repair-request-detail", "work-order-add"].includes(routeFrom)
    );
  },
  methods: {
    getStatisticsServiceRequest() {
      statisticsServiceRequest().then((res) => {
        if (res && res.payload) {
          this.topCardList.map((item) => {
            if (item.name == this.$t("page.repair-request.RequestsThisMonth")) {
              item.value = res.payload["month_requests"];
              item.value1 = res.payload["total_requests"];
            }
            if (
              item.name ==
              this.$t("page.repair-request.PendingRequestsThisMonth")
            ) {
              item.value = res.payload["month_pending_requests"];
              item.value1 = res.payload["total_pending_requests"];
            }
            if (
              item.name ==
              this.$t("page.repair-request.ClosedRequestsThisMonth")
            ) {
              item.value = res.payload["month_closed_requests"];
              item.value1 = res.payload["total_closed_requests"];
            }
            if (
              item.name ==
              this.$t("page.repair-request.CanceledRequestsThisMonth")
            ) {
              item.value = res.payload["month_canceled_requests"];
              item.value1 = res.payload["total_canceled_requests"];
            }
          });
        }
      });
    },
    formatDatetime,
    getStatusTxt,
    filterStatus,
    filterPriority,
    initRepairRequest() {
      this.tableBody = [];
      this.tableLoading = true;
      this.tableLoaded = false;
      const search = {
        page: this.page,
        page_size: this.perPage,
        keyword: null,
        created_at: null,
        priority: null,
        status: null,
        type: null,
      };
      if (this.searchQuery) {
        search["keyword"] = this.searchQuery;
      }
      if (this.filterdate) {
        search["created_at_before"] = this.filterdate;
        search["created_at_after"] = this.filterdate;
      }
      if (this.filtervalue1) {
        search["priority"] = this.filtervalue1;
      }
      if (this.filtervalue2) {
        search["status"] = this.filtervalue2;
      }
      if (this.typeFilter) {
        search["type"] = this.typeFilter;
      }
      getRepairList(search).then((res) => {
        if (res && res.payload) {
          this.tableBody = res.payload.results;
          this.tab_info_length = res.payload.count;
          this.tableLoading = false;
          this.tableLoaded = true;
          this.getStatisticsServiceRequest();
          this.setPages();
        }
      });
      this.getTipsNum(search);
    },
    // 获取待处理的数量
    getTipsNum(search) {
      const param = { ...search, page: 1, page_size: 1 };
      // 待处理
      param["status"] = SERVICE_STATUS_PENDING;
      getRepairList(param).then((res) => {
        if (res && res.payload) {
          this.tabOptions[1]["tipNum"] = res.payload.count;
        }
      });
    },
    /* 设置分页选项 */
    setPages() {
      this.pages = [];
      let numberOfPages = Math.ceil(this.tab_info_length / this.perPage);
      for (let index = 1; index <= numberOfPages; index++) {
        this.pages.push(index);
      }
    },
    // 状态筛选
    checkTab(val) {
      this.filtervalue2 = val;
      this.searchData();
    },
    // 翻页
    pageChange(val) {
      this.page = val;
      this.initRepairRequest();
    },
    // 设置每页条数
    pageSizeChange(val) {
      this.page = 1;
      this.perPage = val;
      this.initRepairRequest();
    },
    resetSearch() {
      this.page = 1;
      this.filterdate = null;
      this.searchQuery = null;
      this.filtervalue1 = null;
      this.typeFilter = null;
      // this.filtervalue2 = null;
      this.initRepairRequest();
    },
    searchData() {
      this.page = 1;
      this.initRepairRequest();
    },
    refresh(currentPage) {
      if (currentPage) {
        this.initRepairRequest();
      } else {
        this.filtervalue2 = "";
        this.resetSearch();
      }
    },
    handlerJump(type, id) {
      switch (type) {
        case "detail":
          this.$router.push({
            path: "/repair-request/detail/" + id,
          });
          break;
        case "add":
          this.$router.push({
            path: "/repair-request/add",
          });
          break;
      }
    },
    handlerAction(type, data) {
      switch (type) {
        case "delete":
          this.closeService(data);
          break;
        case "add":
          this.jumpOrder(data);
          break;
      }
    },
    closeService(data) {
      alertComfirmWithTextarea(
        `${this.$t("page.repair-request.CancelRequest")}?`,
        "",
        this.$t("page.repair-request.PleaseEnterReasonForCancellation")
      ).then((reason) => {
        let params = {
          id: data.id,
          status: SERVICE_STATUS_CLOSED,
          cancel_reason: reason,
        };
        patchRepairService(params.id, params)
          .then((res) => {
            if (res && res.payload) {
              this.initRepairRequest();
              successMsg(this.$t("base.operate_success"));
            }
          })
          .catch(() => {
            alertError(this.$t("base.an-error-occurred"));
          });
      });
    },
    deleteService(data) {
      Swal.fire({
        title: this.$t("base.delete_alert_title"),
        text: this.$t("base.delete_alert_info"),
        icon: "warning",
        showCancelButton: true,
        cancelButtonColor: "#f46a6a",
        confirmButtonColor: "#34c38f",
        confirmButtonText: this.$t("base.done"),
        cancelButtonText: this.$t("base.cancel"),
      }).then((result) => {
        if (result.isConfirmed) {
          deleteRepairService(data.id)
            .then((res) => {
              if (res) {
                Swal.fire(
                  this.$t("base.success"),
                  this.$t("base.delete_alert_completed"),
                  "success"
                );
              }
            })
            .then(() => {
              this.page = 1;
              this.initRepairRequest();
            })
            .catch((e) => {
              this.formValidataAlert = true;
              this.alertInfo = {
                variant: "danger",
                content: e.message,
                icon: "ri-alert-line",
              };
              setTimeout(() => {
                this.formValidataAlert = false;
              }, 4000);
            });
        }
      });
    },
    jumpOrder(data) {
      localStorage.setItem("serviceData", JSON.stringify(data));
      this.$router.push({
        path: "/work-order-add/" + data.type,
        query: {
          // id: data.id,
          create:true,
        },
      });
    },
  },
  components: {
    TableLoading,
    CountTo,
  },
};
</script>

<style scoped lang="scss">
#tasksList {
  flex: 1;
  overflow: hidden;
}
.action-style {
  color: #405189;
  font-size: 18px;
}


</style>
